import { render, staticRenderFns } from "./FormTurmaEdicao.vue?vue&type=template&id=92937d0a"
import script from "./FormTurmaEdicao.vue?vue&type=script&lang=js"
export * from "./FormTurmaEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports